import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import ActionGridEditIcon from "../../pages/actionGrid/ActionGridEditIcon"

const FeatureIconSingle = ({ singleFeature }) => {

  let iconStyle = {
    height: singleFeature.imageHeight > 0 ? singleFeature.imageHeight + "px" : "32" + "px",
    width: singleFeature.imageWidth > 0 ? singleFeature.imageWidth + "px" : "32" + "px",
	background:singleFeature.bgColor?singleFeature.bgColor:''
  }

  let discWidth = singleFeature.descriptionWidth != undefined && singleFeature.descriptionWidth != "undefined" ? singleFeature.descriptionWidth : "col-lg-3";
  let src = singleFeature.link != undefined && singleFeature.link != "undefined" && singleFeature.link != "" ? singleFeature.link : "/";


  return (
    <div className={`antera-action-grid-container ${discWidth} col-sm-6`}>
      <div className="support-wrap mb-30">
        <div className="edit-inline">
          <ActionGridEditIcon actionGridId={singleFeature._id} fromEditAction="image" />
        </div>
        {singleFeature.image && singleFeature.image != 'undefined' && (
          <div className="support-icon">
            <img
              style={iconStyle}
              className="antera-action-grid-image animated"
              src={process.env.PUBLIC_URL + singleFeature.image}
              alt=""
            />
          </div>
        )}
        <div className="support-content">
          <div className="edit-inline">
            <ActionGridEditIcon actionGridId={singleFeature._id} fromEditAction="title" />
            <Link to={src}><h5 dangerouslySetInnerHTML={{ __html: singleFeature.title }} ></h5></Link>

          </div>
          <div className="edit-inline">
            <ActionGridEditIcon actionGridId={singleFeature._id} fromEditAction="description" />
            <p dangerouslySetInnerHTML={{ __html: singleFeature.description }}></p>
          </div>
        </div>
      </div>
    </div>
  );
};

FeatureIconSingle.propTypes = {
  singleFeature: PropTypes.object
};

export default FeatureIconSingle;
